import React from 'react';
import { Navigate, NavLink, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { Card, CardContent } from '../components/ui/card';
import { ShieldCheck, Video, BarChart3, Users, UserPlus, Mail, Gift, Send, Activity, Link2, Award, Presentation, BookOpen, Music, Mic, LineChart, Bell } from 'lucide-react';

const adminItems = [
  { to: '/app/admin/videos', label: 'Videos', icon: Video, testid: 'admin-nav-videos' },
  { to: '/app/admin/grants', label: 'Grants', icon: Gift, testid: 'admin-nav-grants' },
  { to: '/app/admin/ab-tests', label: 'A/B Tests', icon: BarChart3, testid: 'admin-nav-ab' },
  { to: '/app/admin/referrals', label: 'Referrals', icon: Users, testid: 'admin-nav-referrals' },
  { to: '/app/admin/clients', label: 'Clients', icon: UserPlus, testid: 'admin-nav-clients' },
  { to: '/app/admin/subscribers', label: 'Subscribers', icon: Mail, testid: 'admin-nav-subscribers' },
  { to: '/app/admin/coach-users', label: 'Activity', icon: LineChart, testid: 'admin-nav-coach-users' },
  { to: '/app/admin/newsletter', label: 'Newsletter', icon: Send, testid: 'admin-nav-newsletter' },
  { to: '/app/admin/drips', label: 'Drip Stats', icon: Activity, testid: 'admin-nav-drips' },
  { to: '/app/admin/nurture', label: 'Nurture', icon: Activity, testid: 'admin-nav-nurture' },
  { to: '/app/admin/bio-hub', label: 'Bio Hub', icon: Link2, testid: 'admin-nav-biohub' },
  { to: '/app/admin/assessments', label: 'Assessments', icon: Award, testid: 'admin-nav-assessments' },
  { to: '/app/admin/workshops', label: 'Workshops', icon: Presentation, testid: 'admin-nav-workshops' },
  { to: '/app/admin/blog', label: 'Blog', icon: BookOpen, testid: 'admin-nav-blog' },
  { to: '/app/admin/playlists', label: 'Playlists', icon: Music, testid: 'admin-nav-playlists' },
  { to: '/app/admin/audio-drops', label: 'Audio Drops', icon: Mic, testid: 'admin-nav-audio-drops' },
  { to: '/app/admin/push', label: 'Push', icon: Bell, testid: 'admin-nav-push' },
];

export default function AdminLayout() {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="text-sm text-foreground/60" data-testid="admin-loading">Loading…</div>;
  }
  if (!user?.is_admin) {
    return <Navigate to="/app/dashboard" replace />;
  }

  const linkBase = 'flex items-center gap-2 px-3 py-2 rounded-lg text-[13px] font-semibold transition-colors';
  const linkActive = 'bg-[#0a0d0e] text-white';
  const linkIdle = 'text-foreground/70 hover:bg-[#F0F4F4]';

  return (
    <div className="space-y-6" data-testid="admin-shell">
      <div className="flex items-center gap-2.5">
        <div className="w-8 h-8 rounded-lg bg-[#0a0d0e] text-white flex items-center justify-center">
          <ShieldCheck className="h-4 w-4" />
        </div>
        <div>
          <div className="font-mono-accent uppercase tracking-[0.2em] text-[10px] text-foreground/60 font-semibold">Admin</div>
          <h1 className="font-heading text-xl sm:text-2xl font-bold tracking-tight">Admin console</h1>
        </div>
      </div>

      <Card className="border-border">
        <CardContent className="p-2">
          <nav className="flex flex-wrap gap-1" aria-label="Admin navigation">
            {adminItems.map((it) => (
              <NavLink
                key={it.to}
                to={it.to}
                className={({ isActive }) => `${linkBase} ${isActive ? linkActive : linkIdle}`}
                data-testid={it.testid}
                end
              >
                <it.icon className="h-4 w-4" />
                {it.label}
              </NavLink>
            ))}
          </nav>
        </CardContent>
      </Card>

      <Outlet />
    </div>
  );
}
